export default {
  placeholder: 'Restaurant zoeken...',
};
